// 講義ノート一覧（/pages/notes）の検索・絞り込み。一覧のHTMLは build_ssr.mjs が事前描画済みで、ここは絞り込みと全文検索だけを担当する。
// 本文の全文は assets/kl-notes-index.json（{ハンドル: テキスト}）。検索を始めた時に一度だけ読み込む。
(() => {
  const root = document.getElementById("notes-app");
  if (!root) return;
  const $ = (id) => document.getElementById(id);
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));
  let ROWS = [];
  try { ROWS = JSON.parse($("ntData").textContent); } catch (_) { return; }
  const EXAM_NAME = {};
  root.querySelectorAll(".nt-group").forEach((g) => { EXAM_NAME[g.dataset.e] = g.querySelector(".nt-gh").firstChild.textContent; });

  // 全角半角・大小文字・ひらがな/カタカナの違いをならす。文字数は変えない（本文の抜粋位置をそのまま使うため）
  const norm = (s) => {
    let o = "";
    for (const c of String(s)) {
      let n = c.normalize("NFKC");
      if (n.length !== c.length) n = c;
      n = n.toLowerCase();
      const k = n.charCodeAt(0);
      if (n.length === 1 && k >= 0x30a1 && k <= 0x30f6) n = String.fromCharCode(k - 0x60);
      o += n;
    }
    return o;
  };
  ROWS.forEach((r) => { r.nt = norm(r.t); r.ns = norm(r.s); r.nd = norm(r.d + " " + r.l); r.nb = ""; });

  const st = { q: "", e: "", sort: "exam", bodyReady: false };
  const qEl = $("ntQ"), out = $("ntOut"), countEl = $("ntCount"), clearEl = $("ntClear"), sortEl = $("ntSort");
  const groupsHTML = out.innerHTML;

  // ---- 本文インデックスの読み込み（初回の入力時のみ）----
  let loading = false;
  const loadBody = () => {
    if (st.bodyReady || loading) return;
    loading = true;
    fetch(root.dataset.index)
      .then((r) => (r.ok ? r.json() : Promise.reject(r.status)))
      .then((idx) => {
        ROWS.forEach((r) => { r.body = idx[r.h] || ""; r.nb = norm(r.body); });
        st.bodyReady = true;
        render();
      })
      .catch(() => { loading = false; });
  };

  // ---- 検索 ----
  const terms = () => norm(st.q).split(/[\s　]+/).filter(Boolean);
  const search = (ts) => {
    const hits = [];
    for (const r of ROWS) {
      let score = 0, ok = true;
      for (const t of ts) {
        let s = 0;
        if (r.nt.includes(t)) s += 10;
        if (r.ns.includes(t)) s += 5;
        if (r.nd.includes(t)) s += 3;
        if (r.nb.includes(t)) s += 1 + Math.min(r.nb.split(t).length - 1, 5) * 0.2;
        if (!s) { ok = false; break; }
        score += s;
      }
      if (ok) hits.push({ r, score });
    }
    return hits;
  };
  // 本文から検索語の周辺を抜き出し、語を <mark> で囲む
  const mark = (text, ts) => {
    const n = norm(text), rg = [];
    for (const t of ts) { let i = n.indexOf(t); while (i >= 0) { rg.push([i, i + t.length]); i = n.indexOf(t, i + t.length); } }
    rg.sort((a, b) => a[0] - b[0]);
    let o = "", p = 0;
    for (const [a, b] of rg) { if (a < p) continue; o += esc(text.slice(p, a)) + "<mark>" + esc(text.slice(a, b)) + "</mark>"; p = b; }
    return o + esc(text.slice(p));
  };
  const excerpt = (r, ts) => {
    const lines = [[r.d, r.nd.slice(0, r.d.length)], [r.l, r.nd.slice(r.d.length + 1)], [r.body || "", r.nb]];
    for (const [raw, n] of lines) {
      if (!raw) continue;
      const pos = ts.map((t) => n.indexOf(t)).filter((i) => i >= 0);
      if (!pos.length) continue;
      const at = Math.min(...pos);
      const a = Math.max(0, at - 40), b = Math.min(raw.length, at + 90);
      return (a > 0 ? "…" : "") + mark(raw.slice(a, b).replace(/\n/g, " "), ts) + (b < raw.length ? "…" : "");
    }
    return "";
  };

  const itemHTML = (r, ts) => {
    const ex = ts.length ? excerpt(r, ts) : "";
    return `<li class="nt-item" data-h="${r.h}"><a href="/pages/${r.h}"><div><b>${ts.length ? mark(r.t, ts) : esc(r.t)}</b><span class="nt-sub">${esc(EXAM_NAME[r.e] || "")} ｜ ${ts.length ? mark(r.s, ts) : esc(r.s)}</span><p class="nt-d">${ex || esc(r.d)}</p></div><em></em></a></li>`;
  };

  let shown = [];
  const render = () => {
    const ts = terms();
    const all = ts.length ? search(ts) : ROWS.map((r) => ({ r, score: 0 }));
    // 試験ごとの件数（試験の絞り込みは無視して数える）
    const cnt = { "": all.length };
    all.forEach(({ r }) => { cnt[r.e] = (cnt[r.e] || 0) + 1; });
    $("ntChips").querySelectorAll(".nt-chip").forEach((b) => {
      b.querySelector("small").textContent = cnt[b.dataset.e] || 0;
      b.setAttribute("aria-pressed", String(b.dataset.e === st.e));
      b.classList.toggle("is-zero", !(cnt[b.dataset.e] || 0));
    });
    const hits = all.filter(({ r }) => !st.e || r.e === st.e);
    clearEl.hidden = !st.q;
    if (!ts.length && st.sort === "exam") {
      // 既定表示：試験ごとにまとめた事前描画の一覧
      out.innerHTML = groupsHTML;
      out.querySelectorAll(".nt-group").forEach((g) => { g.hidden = !!st.e && g.dataset.e !== st.e; });
      shown = hits.map((x) => x.r);
      countEl.textContent = `${shown.length}本のWebテキスト`;
      return;
    }
    if (ts.length) hits.sort((a, b) => b.score - a.score || (a.r.u < b.r.u ? 1 : -1));
    else hits.sort((a, b) => (a.r.u < b.r.u ? 1 : -1));
    shown = hits.map((x) => x.r);
    out.innerHTML = shown.length
      ? `<ul class="plist nt-list">${hits.map(({ r }) => itemHTML(r, ts)).join("")}</ul>`
      : `<p class="nt-none">「${esc(st.q)}」に合うWebテキストは見つかりませんでした。別のことば（科目名・条文の名前・略称など）でも試してみてください。</p>`;
    countEl.textContent = ts.length
      ? `「${st.q.trim()}」${shown.length}本${st.bodyReady ? "" : "（本文を読み込み中…）"}`
      : `${shown.length}本のWebテキスト（新しい順）`;
  };

  // ---- URL の ?q= &exam= を反映 ----
  const sync = () => {
    try {
      const u = new URL(location.href);
      st.q ? u.searchParams.set("q", st.q) : u.searchParams.delete("q");
      st.e ? u.searchParams.set("exam", st.e) : u.searchParams.delete("exam");
      history.replaceState(null, "", u);
    } catch (_) {}
  };
  const update = () => { render(); sync(); };

  qEl.addEventListener("focus", loadBody);
  qEl.addEventListener("input", () => { st.q = qEl.value; loadBody(); update(); });
  clearEl.addEventListener("click", () => { qEl.value = ""; st.q = ""; update(); qEl.focus(); });
  sortEl.addEventListener("change", () => { st.sort = sortEl.value; update(); });
  $("ntChips").addEventListener("click", (ev) => {
    const b = ev.target.closest(".nt-chip");
    if (!b) return;
    st.e = b.dataset.e;
    update();
  });

  // 表示中の一覧を「タイトル（科目） URL」のテキストでコピー
  $("ntCopy").addEventListener("click", () => {
    const text = shown.map((r) => `${r.t}（${r.s}）\n${location.origin}/pages/${r.h}`).join("\n\n");
    const done = () => { const b = $("ntCopy"), t = b.textContent; b.textContent = "コピーしました"; setTimeout(() => { b.textContent = t; }, 1600); };
    const fallback = () => {
      const ta = document.createElement("textarea");
      ta.value = text; ta.style.position = "fixed"; ta.style.opacity = "0";
      document.body.appendChild(ta); ta.select();
      try { document.execCommand("copy"); done(); } catch (_) {}
      ta.remove();
    };
    navigator.clipboard && navigator.clipboard.writeText ? navigator.clipboard.writeText(text).then(done, fallback) : fallback();
  });

  // 初期状態（共有URLからの復元）
  try {
    const p = new URL(location.href).searchParams;
    st.q = p.get("q") || "";
    const e = p.get("exam") || "";
    st.e = EXAM_NAME[e] ? e : "";
    qEl.value = st.q;
  } catch (_) {}
  if (st.q) loadBody();
  render();
})();
